module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN302_1987544321.e0a82309.png";